import "./membCustLoginCanvas.scss";
import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import CloseIcon from "../../../../../../../assets/CloseIcon";
import Button from "../../../../../../../common/Buttons/Button";
import ArrowNarrowLeft from "../../../../../../../assets/ArrowNarrowLeft";

import VerifyOtp from "./VerifyOTP";
import EnterPhone from "./EnterPhone";
import PaymentFailed from "./PaymentFailed";
import CongratsScreen from "./CongratsScreen";
import PaymentSuccess from "./PaymentSuccess";
import BgVector1 from "./CongratsScreen/BgVector1";
import BgVector2 from "./CongratsScreen/BgVector2";
import AlreadySubscribedMembStep from "./AlreadySubscribed";
import LogoBgAnimatedVector from "./CongratsScreen/LogoBgAnimatedVector";

const initialState = {
  otp: "",
  customer_mobile: "",
  step: "enter-phone", // enter-phone, verify-otp, already-subscribed, payment-success, congrats-screen, payment-failed
  paymentFailedReason: "",
};

const MembershipPurchaseCanvas = ({
  isOpen,
  membership,
  setCurrMemb,
  toggleCanvas,
  isSubsMembExpired,
  membPurchaseDetails,
  setPurchasedInTestStatus,
}) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (membPurchaseDetails?.status) {
      setState((prev) => ({
        ...prev,
        step:
          membPurchaseDetails?.status === "success"
            ? "payment-success"
            : membPurchaseDetails?.status === "failed"
            ? "payment-failed"
            : "",
        paymentFailedReason: membPurchaseDetails?.reason,
      }));
    }
  }, [membPurchaseDetails]);

  useEffect(() => {
    if (state.step === "payment-success") {
      const timer = setTimeout(() => {
        setState((prev) => ({
          ...prev,
          step: "congrats-screen",
        }));
      }, 3000);

      return () => clearTimeout(timer);
    } else if (state.step === "congrats-screen") {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [state.step]);

  const membershipId = membership?._id;
  const membershipEntityId =
    membership?.entity_id?._id ?? membership?.entity_id;
  const themeColor =
    membership?.landing_page_settings?.colors?.theme ?? "#FFCA05";

  const isHideHeader =
    state.step === "payment-success" || state.step === "congrats-screen";

  const handleClose = () => {
    toggleCanvas();
    setState(initialState);
  };

  const handleBack = () => {
    setState((prev) => ({
      ...prev,
      otp: "",
      step: "enter-phone",
    }));
  };

  return (
    <Offcanvas
      show={isOpen}
      placement="bottom"
      onHide={handleClose}
      className={`membership-customer-login-canvas ${
        state.step === "payment-success"
          ? "membership-customer-login-canvas--payment-successfull"
          : state.step === "congrats-screen"
          ? "membership-customer-login-canvas--congrats-screen"
          : ""
      }`}
    >
      <div className="membership-customer-login-canvas-content">
        {!isHideHeader && (
          <Offcanvas.Header>
            {state.step === "verify-otp" ? (
              <Button
                isPlain
                text="Back"
                variant="secondary"
                customClass="back-btn"
                handleClick={handleBack}
                leftIcon={
                  <div className="left-icon">
                    <ArrowNarrowLeft height={16} width={16} />
                  </div>
                }
              />
            ) : (
              <div></div>
            )}
            <div className="right-side">
              <CloseIcon
                width="20"
                height="20"
                color="#FFFFFF"
                handleClick={handleClose}
              />
            </div>
          </Offcanvas.Header>
        )}
        <Offcanvas.Body>
          {state.step === "enter-phone" ? (
            <EnterPhone
              state={state}
              setState={setState}
              membershipId={membershipId}
              isSubsMembExpired={isSubsMembExpired}
              membershipEntityId={membershipEntityId}
              setPurchasedInTestStatus={setPurchasedInTestStatus}
            />
          ) : state.step === "verify-otp" ? (
            <VerifyOtp
              state={state}
              setState={setState}
              membershipId={membershipId}
            />
          ) : state.step === "already-subscribed" ? (
            <AlreadySubscribedMembStep
              setState={setState}
              setCurrMemb={setCurrMemb}
              handleClose={handleClose}
              membershipId={membershipId}
            />
          ) : state.step === "payment-success" ? (
            <PaymentSuccess />
          ) : state.step === "congrats-screen" ? (
            <CongratsScreen membership={membership} />
          ) : state.step === "payment-failed" ? (
            <PaymentFailed state={state} setState={setState} />
          ) : (
            <></>
          )}
        </Offcanvas.Body>
        {state.step === "congrats-screen" && (
          <>
            <BgVector1 color={themeColor} className="bg-vector-1" />
            <LogoBgAnimatedVector color={themeColor} />
            <BgVector2 color={themeColor} className="bg-vector-2" />
          </>
        )}
      </div>
    </Offcanvas>
  );
};

export default MembershipPurchaseCanvas;
